import Vue from "vue";

// Singleton responsible for keeping Authentication layer
function Auth() {
  // Init public vars as reactive
  Vue.util.defineReactive(this, "currentToken", null);
}

Auth.prototype.setToken = function (token) {
  this.currentToken = token;
};

Auth.prototype.isLoggedIn = function () {
  return this.currentToken != null;
};

Auth.prototype.signOut = function () {
  this.setToken(null);
};

// Expose Singleton
export default new Auth();



// WEBPACK FOOTER //
// ./src/services/Auth.js